import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsService } from 'src/app/core/cms.service';
import { LanguageService } from 'src/app/core/language.service';
import { SeoService } from 'src/app/core/seo.service';
import { UnsubscribeResult } from 'src/app/core/cms.models';

@Component({
  selector: 'app-page-unsubscribe',
  templateUrl: './page-unsubscribe.component.html',
  styleUrls: ['./page-unsubscribe.component.css']
})
export class PageUnsubscribeComponent implements OnInit {
  loading = true;
  busy = false;
  token = '';
  result?: UnsubscribeResult;

  constructor(private route: ActivatedRoute, public cms: CmsService,
              public lang: LanguageService, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.setRobots('noindex, follow');
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) { this.loading = false; return; }
    this.cms.unsubscribe(this.token).subscribe({
      next: (r) => { this.result = r; this.loading = false; },
      error: () => { this.result = { found: false, isActive: false }; this.loading = false; }
    });
  }

  resubscribe(): void {
    if (!this.token || this.busy) return;
    this.busy = true;
    this.cms.resubscribe(this.token).subscribe({
      next: (r) => { this.result = r; this.busy = false; },
      error: () => { this.busy = false; }
    });
  }
}
